import Calendar from '@/modules/calendar';
import I18n from '@/modules/i18n';
import Templates from '@/pages/events/templates';

import GridyIndex from '@/controllers/common/gridy_index_controller';

export default class extends GridyIndex {
  connect() {
    super.connect();

    this.grid = $('[data-gridy]');

    this.#bindFilters();

    Calendar.init({
      onEnter: () => this.grid.gridy('refresh'),
      onSelect: () => this.grid.gridy('refresh'),
    });
  }

  gridyOptions() {
    return {
      find: 'events.name',
      paramsElements: ['[data-from]', '[data-status]', '[data-to]'],
      sortName: 'events.start_at',
      sortOrder: 'desc',
      template: Templates.events.gridy,

      headers: [
        { name: I18n.t('activerecord.attributes.event.name'), value: 'events.name' },
        { name: I18n.t('activerecord.attributes.event.start_at'), value: 'events.start_at' },
        { name: I18n.t('activerecord.attributes.event.end_at'), value: 'events.end_at' },
        { name: I18n.t('activerecord.attributes.event.status'), value: 'events.status' },
        { name: I18n.t('activerecord.attributes.event.total_of_votes'), value: 'events.total_of_votes' },
        { name: I18n.t('activerecord.attributes.event.total_of_comments'), value: 'events.total_of_comments' },
        { name: I18n.t('action.other'), value: '' },
      ],
    };
  }

  #bindFilters() {
    $('[data-status]').on('change', () => {
      this.grid.gridy('refresh');
    });
  }
}
